export default __webpack_public_path__ + "static/media/Standard39.ae06d0fe.png";